export function RoomId(val) {
  return val;
}
export function UserId(val) {
  return val;
}
export function SessionId(val) {
  return val;
}
export class BoardLinkError extends Error {
  code;
  details;
  constructor(code, message, details) {
    super(message);
    this.name = 'BoardLinkError';
    this.code = code;
    this.details = details;
    Object.setPrototypeOf(this, BoardLinkError.prototype);
  }
  toJSON() {
    return {
      code: this.code,
      message: this.message,
      details: this.details,
    };
  }
}
export function ok(value) {
  return { ok: true, value };
}
export function fail(error) {
  return { ok: false, error };
}
// Localized Display Name Generator
export function generateDisplayName(locale, seed) {
  const isKo = locale.startsWith('ko');
  const adjectives = isKo
    ? [
        '날쌘',
        '똑똑한',
        '빠른',
        '조용한',
        '밝은',
        '상냥한',
        '황금빛',
        '밤하늘의',
        '야생의',
        '서리내린',
      ]
    : [
        'Sleek',
        'Clever',
        'Swift',
        'Quiet',
        'Bright',
        'Gentle',
        'Golden',
        'Midnight',
        'Wild',
        'Frosty',
      ];
  const nouns = isKo
    ? ['판다', '여우', '수달', '코알라', '매', '올빼미', '오소리', '돌고래', '치타', '여우원숭이']
    : ['Panda', 'Fox', 'Otter', 'Koala', 'Falcon', 'Owl', 'Badger', 'Dolphin', 'Cheetah', 'Lemur'];
  let adjIdx = 0;
  let nounIdx = 0;
  if (seed !== undefined) {
    adjIdx = Math.abs(Math.floor(seed)) % adjectives.length;
    nounIdx = Math.abs(Math.floor(seed * 31)) % nouns.length;
  } else {
    adjIdx = Math.floor(Math.random() * adjectives.length);
    nounIdx = Math.floor(Math.random() * nouns.length);
  }
  return `${adjectives[adjIdx]} ${nouns[nounIdx]}`;
}
//# sourceMappingURL=index.js.map
